// extracted by mini-css-extract-plugin
export default {"wrapper":"UserEmailName_wrapper__lBIdY","avatar":"UserEmailName_avatar__5kCj2","text":"UserEmailName_text__JQlD+","usr_data":"UserEmailName_usr_data__WYIhg"};